export default {

	props: {
		src: {
			type: String,
			//required: true
		},

		width: {
			type: String,
			//required: true
		},

		vip: {
			type: Number
		},

		has_border: {
			type: Boolean,
			default: true
		},

		is_streamer: {
			type: Boolean,
			default: false
		},

		is_robot: {
			type: Boolean,
			default: false,
		},
		curr_metal_url: {
			type: String,
		}
	},

}
